import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {

  constructor(private http: HttpClient) { }

  saveCustomers(id: any, data: any) {
    const { company, ...payload } = data
    if (id) {
      return this.http.put(urls.API_URL + urls.CUSTOMERS + `/${company}/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.CUSTOMERS +'/'+ company, payload)
      .pipe(catchError(errorHandl));

  }

  getCustomers(queryParams:any) {
    const params = new HttpParams({ fromObject: queryParams});
    return this.http.get(urls.API_URL + urls.CUSTOMERS, {params})
      .pipe(catchError(errorHandl));
  }

  getCustomersById(id: any) {
      return this.http.get(urls.API_URL + urls.CUSTOMERS + `/${id}`)
        .pipe(catchError(errorHandl));
  }

  syncCustomer(companyId: any, customerId: any, queryParams: any = {}) {
      const params = new HttpParams({ fromObject: queryParams || {} });
      return this.http.get(urls.API_URL + urls.CUSTOMERS + `/${companyId}/${urls.SYNC}/${customerId}`, { params })
        .pipe(catchError(errorHandl));
  }

}
